import React from "react";
import { ProductConsumer } from "../../../Context/AddProWakel";
import NumberFormat from "react-number-format";
import { multiply } from "lodash";

class FormPrintArz extends React.Component {
  render() {
    return (
      <>
        <ProductConsumer>
          {(value) => {
            const { HK_all3arzKala, HK_draw, HK_name, HK_code } = value;

            const wakil = HK_all3arzKala.filter((data) => {
              if (HK_name != "") {
                return data.nameofproduct.toLowerCase().startsWith(HK_name);
              } else if (HK_code != "") {
                return data.code.toString().startsWith(HK_code);
              } else {
                return data;
              }
            }).map((user, i) => {
              return (
                <>
                  {HK_draw == "دۆلار" || HK_draw == "دینار" ? (
                    <tr key={i} className="f4">
                      <td
                        className="f4 fk"
                        style={{
                          borderBottom: "2px solid black",
                          borderTop: "2px solid black",
                          borderRight: "2px solid black",
                          borderLeft: "2px solid black"
                        }}
                      >
                        {HK_draw == "دۆلار" ? (
                          Number(
                            multiply(
                              Number(user.numberOfDarzan),
                              Number(user.saleDolar)
                            )
                          ).toFixed(2)
                        ) : HK_draw == "دینار" ? (
                          <NumberFormat
                            value={multiply(
                              Number(user.numberOfDarzan).toFixed(2),
                              Number(user.saleDinar).toFixed(2)
                            )}
                            thousandSeparator={true}
                            displayType="text"
                          />
                        ) : null}
                      </td>

                      {HK_draw == "دۆلار" ? (
                        <>
                          {" "}
                          <td
                            className="f4 fk"
                            style={{
                              borderBottom: "2px solid black",
                              borderTop: "2px solid black",
                              borderRight: "2px solid black",
                              borderLeft: "2px solid black"
                            }}
                          >
                            {Number(user.saleDolar).toFixed(2)}
                          </td>
                        </>
                      ) : HK_draw == "دینار" ? (
                        <>
                          {" "}
                          <td
                            className="f4 fk"
                            style={{
                              borderBottom: "2px solid black",
                              borderTop: "2px solid black",
                              borderRight: "2px solid black",
                              borderLeft: "2px solid black"
                            }}
                          >
                            <NumberFormat
                              value={Number(user.saleOfLessTenDarzan)}
                              thousandSeparator={true}
                              displayType="text"
                            />
                          </td>
                          <td
                            className="f4 fk"
                            style={{
                              borderBottom: "2px solid black",
                              borderTop: "2px solid black",
                              borderRight: "2px solid black",
                              borderLeft: "2px solid black"
                            }}
                          >
                            <NumberFormat
                              value={Number(user.saleOfLessHalfCarton)}
                              thousandSeparator={true}
                              displayType="text"
                            />
                          </td>
                          <td
                            className="f4 fk"
                            style={{
                              borderBottom: "2px solid black",
                              borderTop: "2px solid black",
                              borderRight: "2px solid black",
                              borderLeft: "2px solid black"
                            }}
                          >
                            <NumberFormat
                              value={Number(user.saleDinar)}
                              thousandSeparator={true}
                              displayType="text"
                            />
                          </td>
                        </>
                      ) : null}
                      <td
                        className="f4 fk"
                        style={{
                          borderBottom: "2px solid black",
                          borderTop: "2px solid black",
                          borderRight: "2px solid black",
                          borderLeft: "2px solid black"
                        }}
                      >
                        {multiply(user.numberOfDarzan, 12)}
                      </td>
                      <td
                        className="f4 fk"
                        style={{
                          borderBottom: "2px solid black",
                          borderTop: "2px solid black",
                          borderRight: "2px solid black",
                          borderLeft: "2px solid black"
                        }}
                      >
                        {user.numberOfDarzan}
                      </td>
                      <td
                        className="f4 fk"
                        style={{
                          borderBottom: "2px solid black",
                          borderTop: "2px solid black",
                          borderRight: "2px solid black",
                          borderLeft: "2px solid black"
                        }}
                      >
                        1
                      </td>
                      <td
                        className="f4 fk"
                        style={{
                          borderBottom: "2px solid black",
                          borderTop: "2px solid black",
                          borderRight: "2px solid black",
                          borderLeft: "2px solid black"
                        }}
                      >
                        {user.nameofproduct}
                      </td>
                      <td
                        className="f4 fk"
                        style={{
                          borderBottom: "2px solid black",
                          borderTop: "2px solid black",
                          borderRight: "2px solid black",
                          borderLeft: "2px solid black"
                        }}
                      >
                        {user.code}
                      </td>
                    </tr>
                  ) : null}
                </>
              );
            });

            return (
              <table id="example" className="table table-striped  text-right ">
                <thead>
                  <tr
                    className="text-black f4"
                    style={{ backgroundColor: "#2C3539" }}
                  >
                    <th
                      className="f4 fk"
                      style={{
                        borderBottom: "2px solid black",
                        borderTop: "2px solid black",
                        borderRight: "2px solid black",
                        borderLeft: "2px solid black"
                      }}
                    >
                      نرخ کارتۆن
                    </th>
                    {HK_draw == "دۆلار" ? (
                      <>
                        <th
                          className="f4 fk"
                          style={{
                            borderBottom: "2px solid black",
                            borderTop: "2px solid black",
                            borderRight: "2px solid black",
                            borderLeft: "2px solid black"
                          }}
                        >
                          نرخ دەرزەن
                        </th>
                      </>
                    ) : HK_draw == "دینار" ? (
                      <>
                        <th
                          className="f4 fk"
                          style={{
                            borderBottom: "2px solid black",
                            borderTop: "2px solid black",
                            borderRight: "2px solid black",
                            borderLeft: "2px solid black"
                          }}
                        >
                          کەمتر لە 10
                        </th>
                        <th
                          className="f4 fk"
                          style={{
                            borderBottom: "2px solid black",
                            borderTop: "2px solid black",
                            borderRight: "2px solid black",
                            borderLeft: "2px solid black"
                          }}
                        >
                          کەمتر لە نیو
                        </th>
                        <th
                          className="f4 fk"
                          style={{
                            borderBottom: "2px solid black",
                            borderTop: "2px solid black",
                            borderRight: "2px solid black",
                            borderLeft: "2px solid black"
                          }}
                        >
                          نرخ دەرزەن
                        </th>
                      </>
                    ) : null}
                    <th
                      className="f4 fk"
                      style={{
                        borderBottom: "2px solid black",
                        borderTop: "2px solid black",
                        borderRight: "2px solid black",
                        borderLeft: "2px solid black"
                      }}
                    >
                      عدد
                    </th>
                    <th
                      className="f4 fk"
                      style={{
                        borderBottom: "2px solid black",
                        borderTop: "2px solid black",
                        borderRight: "2px solid black",
                        borderLeft: "2px solid black"
                      }}
                    >
                      دەرزەن
                    </th>
                    <th
                      className="f4 fk"
                      style={{
                        borderBottom: "2px solid black",
                        borderTop: "2px solid black",
                        borderRight: "2px solid black",
                        borderLeft: "2px solid black"
                      }}
                    >
                      کارتۆن
                    </th>
                    <th
                      className="f4 fk"
                      style={{
                        borderBottom: "2px solid black",
                        borderTop: "2px solid black",
                        borderRight: "2px solid black",
                        borderLeft: "2px solid black"
                      }}
                    >
                      ناوەی کاڵا
                    </th>
                    <th
                      className="f4 fk"
                      style={{
                        borderBottom: "2px solid black",
                        borderTop: "2px solid black",
                        borderRight: "2px solid black",
                        borderLeft: "2px solid black"
                      }}
                    >
                      کۆد
                    </th>
                  </tr>
                </thead>
                <tbody>{wakil}</tbody>
              </table>
            );
          }}
        </ProductConsumer>
      </>
    );
  }
}
export default FormPrintArz;
